import {Shop} from './Shop';

export interface BuyerInboxThreadData {
  currentUser: CurrentUser;
}

export interface CurrentUser {
  id: number;
  name: string;
  seller: Seller;
  inboxPath: string;
  banned: boolean;
}

export interface Seller {
  id: number;
  listing: Listing;
  messages: Message[];
  replyPath: string;
  makeOfferPath: string;
  offers: Offer[];
  acceptedOffer: Offer;
  blocked: boolean;
}

export interface Listing {
  handle: string;
  id: number;
  sellerName: string;
  shopDomain: string;
  title: string;
  url: string;
  salePrice: string;
}

export interface SellerInboxThreadData {
  ownListing: OwnListing;
}

export interface OwnListing {
  id: number;
  handle: string;
  title: string;
  buyer: Buyer;
  inboxPath: string;
}

export interface Buyer {
  messages: Message[];
  id: number;
  replyPath: string;
  offers: Offer[];
  acceptedOffer: Offer | null;
  blocked: boolean;
  blockBuyerUrl: string;
  unblockBuyerUrl: string;
  name: string;
  banned: boolean;
}

export interface Offer {
  id: number;
  changeOfferStatePath: string;
  amount: number;
  note: string;
  createdAt: string;
  state: OfferState;
  escrowTransaction: EscrowTransaction | null;
}

/* eslint-disable shopify/typescript/prefer-pascal-case-enums */
export enum OfferState {
  'canceled' = 'canceled',
  'accepted' = 'accepted',
  'rejected' = 'rejected',
  'opened' = 'opened',
  'failed' = 'failed',
}

export enum LeadUserType {
  'buyer' = 'buyer',
  'seller' = 'seller',
}

export enum OfferErrorType {
  'SERVER_ERROR' = 'SERVER_ERROR',
  'TRANSACTION_ERROR' = 'TRANSACTION_ERROR',
  'REALTIME_ERROR' = 'REALTIME_ERROR',
  'BLOCKED_NO_ACCEPT_OFFER' = 'BLOCKED_NO_ACCEPT_OFFER',
}
/* eslint-enable shopify/typescript/prefer-pascal-case-enums */

export interface EscrowTransaction {
  description: string;
  escrowId: number;
  createdAt: string;
  id: number;
  path: string;
  offer: Offer;
  amount: number;
}

export interface Message {
  createdAtAgo?: string;
  createdAt: string;
  id: number;
  fromUser?: User;
  toUser?: User;
  attachments: Attachment[];
  messageText: string;
  isFromLead?: boolean;
  isFromSeller: boolean;
  text?: string;
}

export interface Attachment {
  url: string;
  filename: string;
}

interface User {
  id: number;
  name: string;
  email?: string;
  banned: boolean;
  linkedinProfileUrl: string;
}

export interface ListingLead {
  id: number;
  listing: Shop;
  messages: Message[];
}
